import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../environments/environment";
import * as CryptoJS from "crypto-js";
import { map, catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { HttpParams } from "@angular/common/http";
@Injectable({
  providedIn: "root",
})
export class AppService {
  option: any;
  encryptedData: any;
  headers: any;
  user: any;
  userInfo: any = {};
  app_language: any;
  heartBeatInterval: any = [];
  constructor(private httpClient: HttpClient) {
    this.updateToken();
  }
  updateToken(): void {
    this.app_language = JSON.parse(
      localStorage.getItem(environment.localStorageLangKey)
    );
    this.encryptedData = localStorage.getItem(environment.localStorageKey);
    if (this.encryptedData) {
      this.encryptedData = JSON.parse(
        CryptoJS.AES.decrypt(
          this.encryptedData,
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );
      const headers = new HttpHeaders()
        .set("Authorization", "Bearer " + this.encryptedData.token)
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("language", this.app_language);
      this.option = { headers };
    }
  }
  footerContent(data: any): Observable<any> {
    return this.httpClient.get(
      environment.apiUrl + "app-content?type=" + data.type
    );
  }

  // terms(data): Observable<any> {
  //   return this.httpClient.get(environment.apiUrl + "page?type=" + data.type);
  // }

  contactUs(data: any): Observable<any> {
    const body = new HttpParams()
      .set("subject", data.subject)
      .set("query", data.message)
      .set("email", data.email)
      .set("name", data.name)
      .set("mobile", data.mobile)
      .set("rtoken", data.rtoken);
    return this.httpClient
      .post(environment.apiUrl + "contactUs", body, this.option)
      .pipe(
        map((data: any) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({ status: error.status, datas: error.statusText });
        })
      );
  }
  addContinueWatching(data: any): Observable<any> {
    this.updateToken();
    const body = new HttpParams()
      .set("content_id", data.contentId)
      .set("view_duration", data.viewDuration)
      .set("status", data.status)
      .set("device_type", data.device_type)
      .set("total_duration", data.totalDuration)
      .set("type", data.type)
      .set("series_id", data.series_id ? data.series_id : "")
      .set("partner_id", data.partner_id)
      .set("profile_id", this.encryptedData.profile_id);

    return this.httpClient
      .post(
        environment.apiUrl + "content/add-continue-watching",
        body,
        this.option
      )
      .pipe(
        map((data: any) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({ status: error.status, datas: error.statusText });
        })
      );
  }
  addImpression(data: any): Observable<any> {
    this.updateToken();
    const body = new HttpParams()
      .set("content_id", data.content_id)
      .set("series_id", data.series_id)
      .set("partner_id", data.partner_id)
      .set("view_duration", data.view_duration)
      .set("skip_status", data.skip_status)
      .set("device_type", "web")
      .set("total_duration", data.total_duration)
      .set("type", data.type)
      .set("url", data.url)
      .set("advertisement_id", data.advertisement_id);
    return this.httpClient
      .post(environment.apiUrl + "content/impression", body, this.option)
      .pipe(
        map((data: any) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({ status: error.status, datas: error.statusText });
        })
      );
  }
  faq(): Observable<any> {
    this.updateToken();
    return this.httpClient.get(environment.apiBaseUrl + "faq", this.option);
  }

  testimonials(): Observable<any> {
    //api.app.com/api/testimonials?limit=10&offset=0
    this.updateToken();
    return this.httpClient.get(
      environment.apiUrl + "testimonials" + "?limit=" + 10 + "&offset=" + 0,
      this.option
    );
  }

  baseApi(): Observable<any> {
    this.updateToken();
    return this.httpClient.get(
      environment.apiBaseUrl + "base-url?device_type=web&app_version=1.0",
      this.option
    );
  }

  oneSignalInfo(userId: any): Observable<any> {
    this.updateToken();
    return this.httpClient.get(
      "https://onesignal.com/api/v1/players/" +
        userId +
        "?app_id=6bb52300-c53a-4d56-a977-bfde08f871ee",
      this.option
    );
  }
  heartBeat(data: any): Observable<any> {
    this.updateToken();
    return this.httpClient
      .get(
        environment.apiBaseUrl + "heartbeat?device_id=" + data.device_id,
        this.option
      )
      .pipe(
        catchError((error) => {
          return throwError({
            status: error.status,
            datas: error.statusText,
            type: error.error.type,
          });
        })
      );
  }

  addProfile(data: any) {
    this.updateToken();
    const body = new HttpParams()
      .set("name", data.name)
      .set("child_status", data.status)
      .set("color", data.color ? data.color : "");
    return this.httpClient.post(
      environment.apiBaseUrl + "people/profile",
      body,
      this.option
    );
  }
  editProfile(data: any) {
    this.updateToken();
    const body = new HttpParams()
      .set("name", data.name)
      .set("child_status", data.child_status ? data.child_status : "")
      .set("color", data.color ? data.color : "")
      .set("id", data.id);
    return this.httpClient.put(
      environment.apiBaseUrl + "people/profile",
      body,
      this.option
    );
  }
  getPeopleList() {
    this.updateToken();
    return this.httpClient.get(
      environment.apiBaseUrl + "people/profile",
      this.option
    );
  }
  profileDetail(id: any) {
    this.updateToken();
    return this.httpClient.get(
      environment.apiBaseUrl + "people/profile/" + id,
      this.option
    );
  }
  removeProfile(id: any) {
    this.updateToken();
    return this.httpClient.delete(
      environment.apiBaseUrl + "people/profile/" + id,
      this.option
    );
  }
}
